export const Types = {
  Image: 1,
  Pdf: 2,
  Advertisement: 3,
  Video: 4,
  Recents: 5,
};

export const IconTypes = {
  Danger: 1,
  Alert: 2,
  Check: 3,
  Form: 4,
};

export const VALID_TYPES = {
  [Types.Image]: ['image/jpeg', 'image/jpg', 'image/png', 'image/webp', 'image/svg+xml'],
  [Types.Pdf]: ['application/pdf'],
  [Types.Video]: [
    'video/mp4',
    'video/quicktime',
    'video/webm',
    'video/ogg',
    'image/gif'
  ],
};